// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"f284a2a9","232":"1c7ceaed","237":"eeabc082","244":"d1ab17a2","344":"83cf7462","357":"0a6d331d","526":"7a53fd6d","652":"ec25f21c","753":"d202f4a1","803":"b02fdd90","854":"50756526","872":"524cd729","889":"fa4aaaf9"}[chunkId] + ".chunk.js";
};